import React from "react";

import classNames from "classnames";
import _ from "underscore";
import pick from "lodash/pick";
import isPlainObject from "lodash/isPlainObject";
import PropTypes from 'prop-types';

import MultiSelect from "shared/react_components/MultiSelect";
import { Control, Dropdown } from "shared/react_components/Filter";

import windowHelpers from "../utils/windowHelpers";

import $ from "jquery";
import "jquery-deparam";

let ITEMS_PAGE_LIMIT = 30;
let ITEMS_INITIAL_OFFSET = 0;

class MultiSelectFilter extends React.Component {
  constructor(...args) {
    super(...args);

    this.removeFilter = this.removeFilter.bind(this);
    this._onScroll = this._onScroll.bind(this);
    this._handleChange = this._handleChange.bind(this);
    this._handleSearch = this._handleSearch.bind(this);
    this._onApply = this._onApply.bind(this);
    this._onApplyForCustomComponent = this._onApplyForCustomComponent.bind(this);
    this._applySelected = this._applySelected.bind(this);
    this._onCancel = this._onCancel.bind(this);
    this._onBlur = this._onBlur.bind(this);

    let initialItems = [];
    if (_.isArray(this.props.initialItems) && _.isObject(this.props.initialItems[0])) {
      initialItems = this.props.initialItems.map(function(item) {
        item.checked = true;
        return item;
      });
    }

    this.state = {
      items: initialItems,
      offset: ITEMS_PAGE_LIMIT,
      loading: true,
      maxItems: 0,
      appliedItems: initialItems,
      appliedUrlParamsToInclude: this._urlParamValuesToInclude()
    };
  }

  componentDidMount() {
    if (this.props.url) {
      this._fetchItemsFromRemote('', _.isEmpty(this.state.appliedItems));
    } else {
      if (isPlainObject(this.props.initialItems)) {
        this._loadItemsFromParamObjValues();
      } else {
        this._loadItemsFromArrValues();
      }
    }
  }

  render() {
    const {
      name,
      fixedWidth,
      open,
      hideActionButtons,
      maxItems,
      onRemoveFilter,
      customSelection
    } = this.props;
    const { query, appliedItems, items } = this.state;
    const canFilter = this._canFilter();
    const onRemove = onRemoveFilter && this.removeFilter;

    return (
      <div className={classNames('multiselect-dropdown-container', name, { 'fixed-width': fixedWidth })}>
        {this._renderStackedControlTitle()}
        <div className="d-flex align-items-center">
          <Dropdown
            toggleClassName="multiselect-dropdown-button"
            applied={!_.isEmpty(appliedItems)}
            initialOpen={open}
            label={`${this._renderTitlePrefix()}${this._renderTitle()}`}
            onRemove={onRemove}
          >
            {({ toggle, isOpen }) => {
              if (isOpen) this._onDropdownOpen();
              const onCancel = event => { toggle(); this._onCancel(event); };

              return (
                <div className="scrollableList" onScroll={this._onScroll}>
                  {customSelection ? (
                    customSelection({
                      items: this.state.items,
                      onFilterApply: (itemsForMultiSelect, params) => {
                        this._onApplyForCustomComponent(itemsForMultiSelect, params);
                        toggle();
                      },
                      canFilter: canFilter,
                      onCancel: onCancel
                    })
                  ) : (
                    <>
                      <MultiSelect
                        showInvertBar
                        options={this._mapToLabel(items || [])}
                        onSearch={_.debounce(this._handleSearch, 200)}
                        selectedOptions={this._mapToLabel(this._getSelectedItemsArray())}
                        onSelectionChanged={this._handleChange}
                        initialSearch={query}
                        onBlur={this._onBlur}
                      />
                      {this._getLoadingIndicator()}
                    </>
                  )}
                  {!hideActionButtons && (
                    <>
                      {!customSelection && (
                        <Control
                          applyEnabled={canFilter}
                          onApply={event => { toggle(); this._onApply(event); }}
                          onCancel={onCancel}
                        />
                      )}
                      {!canFilter && (
                        <div className='multiselect-dropdown-alert'>
                          <div className='alert alert-danger mb-0 mt-2' role='alert'>Too many filters! Up to {maxItems || 150} filters are supported.</div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              );
            }}
          </Dropdown>
        </div>
      </div>
    );
  }

  _onDropdownOpen() {
    const { appliedUrlParamsToInclude } = this.state;
    const currentUrlParamsToInclude = this._urlParamValuesToInclude();
    if (this.props.url && !_.isEqual(appliedUrlParamsToInclude, currentUrlParamsToInclude)) {
      this.setState(
        { appliedUrlParamsToInclude: currentUrlParamsToInclude },
        () => this._fetchItemsFromRemote('', _.isEmpty(this.state.appliedItems))
      );
    }
  }

  _renderStackedControlTitle() {
    if (!this.props.hideLabel) {
      return (
        <div className='multiselect-dropdown-title'>
          {this.props.title}
        </div>
      );
    }
  }

  _handleChange(selectedItems) {
    const items = this.state.items;
    const mappedItems = items.map(item => {
      const index = _.findLastIndex(selectedItems, {
        value: item.id
      });

      return { ...item, checked: index >= 0 };
    });

    this.setState({ items: mappedItems });
  }

  _handleSearch(query) {
    if (this.props.url) {
      this.setState({
        query: query,
        offset: ITEMS_PAGE_LIMIT
      });
      this._fetchItemsFromRemote(query, false);
    } else {
      let filteredItems = this.props.values.items.filter(item => { return item.text.toLowerCase().indexOf(query.toLowerCase()) >= 0; });
      let filteredSelectedItems = filteredItems.filter(this._isSelected);

      this.setState({
        query: query,
        items: filteredItems,
        appliedItems: filteredSelectedItems
      });
    }
  }

  _isSelected(value) {
    return value.checked;
  }

  _isUnselected(value) {
    return !value.checked;
  }

  _getSelectedItems() {
    return this.state.items.filter(this._isSelected);
  }

  _getLoadingIndicator() {
    if (this.state.loading === true) {
      return (<div data-mount='loading'>Loading more items...</div>);
    }
  }

  _mapToLabel(array) {
    return array.map(({ text, id }) => ({ label: this._getDescription(text), value: id }));
  }

  _getDescription(text) {
    switch (text) {
    case "":
      return "(Blank)";
    case null:
      return "(Not Present)";
    default:
      return text;
    }
  }

  _getSelectedItemsArray() {
    const items = this.state.items || [];
    return items.filter(this._isSelected);
  }

  _requestHeaders() {
    var requestHeaders = {
      'X-Select2': '1'
    };

    if (this.props.isReportFilter !== false) {
      requestHeaders['X-Report-Filter'] = '1';
    }

    return requestHeaders;
  }

  _loadItemsFromParamObjValues() {
    const items = this
      .props
      .values
      .items
      .map(({ id, text }) => ({
        id,
        text,
        checked: this.props.initialItems.hasOwnProperty(id),
        paramValues: this.props.initialItems[id]
      }));

    this.setState({
      items: items,
      appliedItems: this.props.initialItems
    });
  }

  _loadItemsFromArrValues() {
    if (typeof this.props.initialItems !== 'undefined') {
      let selectedItems = [];

      this.props.initialItems.forEach(item => {
        // initial items are just an array of IDs, for local lists we need to convert to array of hashes
        //  using the friendly name from the full list
        let selectedItem = _.findWhere(this.props.values.items, { id: item }) || { text: item };
        selectedItems.push({ id: item, text: selectedItem.text });
      });

      this.props.values.selected_items = selectedItems;
    }

    this._setCheckStatus(this.props.values);
  }

  _fetchItemsFromRemote(query = '', useInitial = true) {
    const [pathname, urlParams] = this.props.url.split('?');
    const { appliedUrlParamsToInclude } = this.state;
    const params = {
      ...$.deparam(urlParams || ''),
      ...appliedUrlParamsToInclude,
      limit: ITEMS_PAGE_LIMIT,
      query,
      start: ITEMS_INITIAL_OFFSET
    };
    if (typeof this.props.initialItems !== 'undefined' && useInitial) {
      params.selected_ids = this.props.initialItems;
    }

    const url = `${pathname}?${$.param(params)}`;
    $.ajax({
      url: url,
      headers: this._requestHeaders(),
      success: function(data) {
        data.items = this._itemsWithStringNull(data.items);
        data.selected_items = this._itemsWithStringNull(data.selected_items);
        this._setCheckStatus(data);
      }.bind(this)
    });
  }

  _itemsWithStringNull(data) {
    return _.map(data, function(row) {
      if (row.id === null) {
        row.id = 'null';
      }
      return row;
    });
  }

  // unlike fetch items, onInfiniteload concatenates new data in
  _onInfiniteScroll() {
    const [pathname, urlParams] = this.props.url.split('?');
    const { query, offset: start, appliedUrlParamsToInclude } = this.state;
    const params = {
      ...$.deparam(urlParams || ''),
      ...appliedUrlParamsToInclude,
      limit: ITEMS_PAGE_LIMIT,
      query,
      start
    };
    const url = `${pathname}?${$.param(params)}`;
    this.setState({
      loading: true
    });
    $.ajax({
      url: url,
      headers: this._requestHeaders(),
      success: function(data) {
        var items = this._itemsWithStringNull(this.state.items.concat(data.items));
        var newOffset = this.state.offset + ITEMS_PAGE_LIMIT;
        this.setState({
          items: this._enforceUniqueItems(items),
          offset: newOffset,
          loading: false,
          maxItems: data.total_results
        });
      }.bind(this)
    });
  }

  _setCheckStatus(data) {
    // get the current selected items
    var selectedItems = this._getSelectedItems();

    // Push the pre-selected items that came in the url params, if they did
    // and mark them as checked
    if (typeof data.selected_items !== 'undefined') {
      data.selected_items = data.selected_items.map(function(item) {
        item.checked = true;
        return item;
      });
      selectedItems = this._enforceUniqueItems(selectedItems.concat(data.selected_items || []));
    }

    // get the available items off the server, server doesn't know about checked or not
    var itemPool = data.items || [];

    // remove selected items off the item pool
    for (var i = 0; i < selectedItems.length; i++) {
      itemPool = _.reject(itemPool, function(item) {
        return item.id === selectedItems[i].id;
      });
    }

    // now make what's left of itemPool values false
    itemPool.map(function(item) {
      item.checked = false;
      return item;
    });

    this.setState({
      items: selectedItems.concat(itemPool),
      appliedItems: selectedItems,
      loading: false,
      maxItems: data.total_results
    });
  }

  _renderTitle() {
    var selectedItems = this._getSelectedItems();
    if (selectedItems.length === 0) {
      return `Select ${this.props.title}`;
    } else if (selectedItems.length === 1) {
      return this._getDescription(selectedItems[0].text);
    } else {
      if (this._showAllItemsSelectedText()) {
        return this.props.allSelectedText;
      } else {
        return `${selectedItems.length} selected`;
      }
    }
  }

  _renderTitlePrefix() {
    var selectedItems = this._getSelectedItems();
    if (this.props.hideLabel && !this.props.hideTitlePrefix && selectedItems.length > 0) {
      return `${this.props.title}: `;
    } else {
      return '';
    }
  }

  _showAllItemsSelectedText() {
    var selectedItems = this._getSelectedItems();
    return selectedItems.length === this.state.items.length && this.props.allSelectedText;
  }

  // On apply, fetch items to rehydrate list, execute callback and update appliedItems
  _onApply(evt) {
    evt.preventDefault();

    this._applySelected(this._getSelectedItems());
    if (this.props.url) {
      this._fetchItemsFromRemote('', false);
    }
  }

  _onApplyForCustomComponent(itemsForMultiSelect, appliedItems) {
    this.setState({
      items: itemsForMultiSelect
    });
    this._applySelected(appliedItems);
  }

  _applySelected(appliedItems) {
    this.setState({
      appliedItems,
      offset: ITEMS_PAGE_LIMIT
    });
    this.props.onApply(appliedItems, this.props.name);
  }

  _onCancel(evt) {
    evt.preventDefault();

    if (this.props.url) {
      // todo refactor next time in here - noticed on tail end of QA this existing logic, not sure why the below logic exists
      // this control should take a snapshot of the items on open (or on data fetches) and then cancel should rollback
      // to the latest known selection state
      this.setState({
        items: this.state.appliedItems,
        offset: ITEMS_PAGE_LIMIT
      });
      this._fetchItemsFromRemote('', false);
    }

    // for now local lists just stay as is (no filter change event fires, but selections while control was open since
    // last apply is not rollbacked - see above todo for cleaning this up for ajax & local lists
    if (_.isEmpty(this.state.appliedItems) && this.props.onRemoveFilter) {
      this.removeFilter(evt);
    }
  }

  _onBlur() {
    const { onBlur, name } = this.props;
    if (!_.isUndefined(onBlur)) {
      const selectedItems = this._getSelectedItems();
      this.setState({
        appliedItems: selectedItems,
        offset: ITEMS_PAGE_LIMIT
      });
      onBlur(selectedItems, name);
    }
  }

  removeFilter(evt) {
    evt.preventDefault();
    this.props.onRemoveFilter(this.props.name);
  }

  _onScroll(event) {
    var $list = $(event.target);
    var delta = $list[0].scrollHeight - $list.scrollTop();
    if (delta < 500 && this.state.maxItems > this.state.items.length && this.state.loading === false) {
      this._onInfiniteScroll();
    }
  }

  _enforceUniqueItems(items) {
    return _.uniq(items, 'id');
  }

  _canFilter() {
    if (this.props.canFilter) {
      return this.props.canFilter(this._getSelectedItems(), this.props.name);
    } else {
      return true;
    }
  }

  _urlParamValuesToInclude() {
    const [, urlParams = ""] = windowHelpers.locationHref().split("?");
    const params = $.deparam(urlParams);
    const { includeUrlParams } = this.props;

    return pick(params, includeUrlParams);
  }
}

MultiSelectFilter.propTypes = {
  customSelection: PropTypes.func,
  name:           PropTypes.string,
  title:          PropTypes.string,
  allSelectedText: PropTypes.string,
  canFilter:      PropTypes.func,
  url:            PropTypes.string,
  fixedWidth:      PropTypes.bool,
  hideActionButtons: PropTypes.bool,
  hideLabel:      PropTypes.bool,
  hideTitlePrefix: PropTypes.bool,
  isReportFilter:  PropTypes.bool,
  open:           PropTypes.bool,
  show:           PropTypes.bool,
  values:         PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id:   PropTypes.node.isRequired,
        text: PropTypes.string
      })
    ).isRequired,
    selected_items: PropTypes.arrayOf(
      PropTypes.shape({
        id:   PropTypes.node.isRequired,
        text: PropTypes.string
      })
    )
  }),
  initialItems:   PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  maxItems:       PropTypes.number,

  onApply:        PropTypes.func,
  onBlur:         PropTypes.func,
  onRemoveFilter: PropTypes.func,
  includeUrlParams: PropTypes.arrayOf(PropTypes.string)
};

MultiSelectFilter.defaultProps = {
  includeUrlParams: []
};

export default MultiSelectFilter;
